import { BrowserRouter, Routes as ReactRoutes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import App from "./App";
import ShopIndexPage from "pages/shops/index/ShopIndexPage";
import ShopEditPage from "pages/shops/edit/ShopEditPage";
import ShopInventoryPage from "pages/shops/inventory/ShopInventoryPage";
import ShopInventoryProposalPage from "pages/shops/inventory_proposal/ShopInventoryProposalPage";
import LoginPage from "pages/login/LoginPage";
import CustomerJourneysIndexPage from "pages/customers_journeys/index/CustomerJourneysIndexPage";
import { Feature, getCurrentUser, useAuthorization } from "user";
import StatsIndexPage from "pages/stats/index/StatsIndexPage";
import ShopInventoryComparator from "pages/shops/inventory_proposal/ShopInventoryComparator";
import AccessibilityPage from "pages/accessibility/AccessibilityPage";

const buildPageTitle = (pathname: string, t: (key: string) => string) => {
  if (pathname.startsWith("/shops/") && pathname.includes("/inventory_proposal/")) return `${t("shop.index.propose")} - THOMerch`;
  if (pathname.startsWith("/shops/") && pathname.includes("/compare")) return `${t("shop.index.compare")} - THOMerch`;
  if (pathname.startsWith("/shops/") && pathname.includes("/inventory")) return `${t("shop.index.inventory")} - THOMerch`;
  if (pathname.startsWith("/shops/") && pathname.includes("/edit")) return `${t("shop.index.edit")} - THOMerch`;
  if (pathname.startsWith("/shops")) return `${t("menu.shops")} - THOMerch`;
  if (pathname.startsWith("/customer_journeys")) return `${t("menu.customersJourneys")} - THOMerch`;
  if (pathname.startsWith("/stats")) return `${t("menu.stats")} - THOMerch`;
  if (pathname.startsWith("/accessibility")) return `${t("menu.accessibility")} - THOMerch`;
  return `${t("connect")} - THOMerch`;
};

const DocumentTitle = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    document.title = buildPageTitle(location.pathname, t);
  }, [location.pathname, t]);

  return null;
};

const Routes = () => {
  const loggedIn = Boolean(getCurrentUser());
  const hasAccess = useAuthorization();

  return (
    <BrowserRouter>
      <DocumentTitle />
      <ReactRoutes>
        {loggedIn ? (
          <Route path="/" element={<App />}>
            <Route index element={<Navigate to="/shops" replace />} />
            <Route path="shops" element={<Outlet />}>
              <Route index element={<ShopIndexPage />} />
              {hasAccess(Feature.ShopEdit) && <Route path=":erpId/edit" element={<ShopEditPage />} />}
              <Route path=":erpId/inventory" element={<ShopInventoryPage />} />
              {hasAccess(Feature.ShopPropose) && (
                <Route path=":erpId/inventory_proposal/:proposalId" element={<ShopInventoryProposalPage />} />
              )}
              {hasAccess(Feature.ShopComparator) && (
                <Route path=":erpId/compare/" element={<ShopInventoryComparator />} />
              )}
            </Route>
            {hasAccess(Feature.CustomerJourneys) && (
              <Route path="customer_journeys" element={<CustomerJourneysIndexPage />}></Route>
            )}
            {hasAccess(Feature.Stats) && <Route path="stats" element={<StatsIndexPage />}></Route>}
            <Route path="accessibility" element={<AccessibilityPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        ) : (
          <>
            <Route index element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </ReactRoutes>
    </BrowserRouter>
  );
};

export default Routes;
